{
  // content-full-bleed-media: the image breaks out of the wrapper to the viewport edge
  // while the text content stays inside the wrapper. CSS can't size the breakout reliably
  // across widths, so we measure the in-wrapper content column and size the absolute image
  // to meet its edge — the rest of the block obeys the standard wrapper/padding rules.
  const sizeImages = () => {
    document.querySelectorAll('.content-full-bleed-media').forEach(block => {
      const image = block.querySelector('.content-full-bleed-media--image')
      const content = block.querySelector('.content-full-bleed-media--content')
      if (!image || !content) return

      // below the breakpoint the block stacks — clear inline sizing, let CSS take over
      if (window.innerWidth <= 768) {
        image.style.width = ''
        return
      }

      const contentRect = content.getBoundingClientRect()
      const isLeft = block.classList.contains('content-full-bleed-media--image-left')

      // clientWidth, not innerWidth — the layout viewport excludes the scrollbar the image is anchored to
      image.style.width = isLeft
        ? Math.max(0, contentRect.left) + 'px'
        : Math.max(0, document.documentElement.clientWidth - contentRect.right) + 'px'
    })
  }

  window.addEventListener('load', sizeImages)
  window.addEventListener('resize', sizeImages)

  sizeImages()
}
